  document.addEventListener('DOMContentLoaded', () => {
    const targetParagraph = document.querySelector('.slider-text-container');
    const absoluteDots = document.querySelector('.pdp-slider-pagination');

    if (targetParagraph && absoluteDots) {
      const adjustDotsWidth = () => {
        if (window.innerWidth > 768) {
          const paragraphWidth = targetParagraph.offsetWidth; // Get width of the p element
          absoluteDots.style.width = `${paragraphWidth}px`; // Set width to match
          // absoluteDots.style.marginBottom = '1.875rem';
        } else {
          absoluteDots.style.width = '100%'; // Set width to 100%
        }
      };

      // Initial adjustment
      adjustDotsWidth();

      // Adjust on resize
      window.addEventListener('resize', adjustDotsWidth);
    } 
    // else {
    //   console.log('Required elements not found');
    // } 
  });